import { SettingsParser } from "./settings-parser";
import { ChannelConfigurationCommonSettings } from "../settings/channel-configuration-common-settings";

export class CommonChannelConfigurationParser extends SettingsParser {
  constructor(signalParser) {
    super();
    this.parsedFieldNames = ["name", "signals"];
    this.signalParser = signalParser;
  }

  static createSettings(settings, defaultSettings, signalParser) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      name: settings.name
    };
    if (settings.signals !== undefined && signalParser !== undefined) {
      parsedSettings.signals = [];
      for (let signalIndex = 0; signalIndex < settings.signals.length; signalIndex++) {
        let signalSettings = signalParser.parse(settings.signals[signalIndex], defaultSettings?.signal);
        if (signalSettings !== undefined) {
          parsedSettings.signals.push(signalSettings);
        }
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = CommonChannelConfigurationParser.createSettings(settings, defaultSettings, this.signalParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new ChannelConfigurationCommonSettings(parsedSettings);
  }
}
